"use client";

import { useEffect, useState } from "react";
import { useSpineSlice } from "@/components/site/motion/useSpineSlice";
import { Meteors } from "@/components/ui/meteors";
import { SparklesCore } from "@/components/ui/sparkles";
import { useContent } from "@/components/site/ContentProvider";
import styles from "./hero-sparkles.module.css";

/** Desktop-only meteors (≥601px). Mobile founder feedback: no shower. */
function useDesktopMeteors() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 601px)");
    const sync = () => setShow(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);
  return show;
}

export function Hero() {
  useSpineSlice((m) => {
    m.spine!.buildHeroA();
    m.spine!.buildHeroB();
    m.setJumpIndex(1);
  });

  const site = useContent();
  const lines = site.hero.lines;
  const lastIndex = lines.length - 1;
  const showMeteors = useDesktopMeteors();

  return (
    <div
      className={`landing_content hero_content f f-c a-c j-c ${styles.hero}`}
      id="hero"
    >
      {showMeteors ? (
        <div className={styles.meteors} data-meteors-host aria-hidden="true">
          <Meteors number={24} angle={230} />
        </div>
      ) : null}
      <div className={`label light_80 _hero_ele ${styles.subhead}`}>
        {site.hero.subhead}
      </div>
      <h1 className={`hero_head f f-c a-c j-c ${styles.head}`}>
        {lines.map((line, index) => {
          const isOutcomes = index === lastIndex;
          return (
            <div
              className={`hero_head_line f a-c${isOutcomes ? ` ${styles.outcomesLine}` : ""}`}
              key={line}
            >
              <span
                className={`hero_title _hero_ele${isOutcomes ? ` ${styles.outcomesTitle}` : ""}`}
              >
                {line}
              </span>
              {isOutcomes ? (
                <div className={styles.band} aria-hidden="true">
                  <div className={styles.glowWide} />
                  <div className={styles.lineWide} />
                  <div className={styles.glowNarrow} />
                  <div className={styles.lineNarrow} />
                  <SparklesCore
                    id="xattir-hero-outcomes-sparkles"
                    background="transparent"
                    minSize={0.4}
                    maxSize={1}
                    particleDensity={420}
                    className={styles.bandCore}
                    particleColor="#FFFFFF"
                    speed={4}
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </h1>
    </div>
  );
}
